import { Switch } from '@headlessui/react';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

/**
 * @param label what this switch turns on, read out by a screen reader. Several
 *  of these sit next to each other on a settings screen, and the visible text
 *  beside them isn't attached to the control, so without one they all announce
 *  the same thing.
 */
const Toggle = ({ enabled, setEnabled, className, label }) => {
    return (
        <Switch
            checked={enabled}
            onChange={setEnabled}
            className={classNames(
                enabled ? 'bg-primary-700' : 'bg-[#D0D0D0]',
                'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-700 focus:ring-offset-2',
                className,
            )}
        >
            <span className="sr-only">{label || 'Use setting'}</span>
            <span
                aria-hidden="true"
                className={classNames(
                    enabled ? 'translate-x-5' : 'translate-x-0',
                    'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
                )}
            />
        </Switch>
    );
};

export default Toggle;
